(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["modals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function dialogFor(id) {
      try { return document.querySelector('dialog[data-modal-widget="' + CSS.escape(id) + '"]'); }
      catch (e) { return null; }
    }

    function openModal(id) {
      var dlg = dialogFor(id);
      if (!dlg || dlg.open || typeof dlg.showModal !== 'function') return false;
      dlg.showModal();
      document.documentElement.classList.add('mw-scroll-lock');
      return true;
    }

    function closeModal(dlg) {
      if (!dlg || !dlg.open) return;
      dlg.close(); // CSS handles the exit animation via allow-discrete
    }

    // Open: intercept clicks on data-modal-open OR anchor links whose hash
    // matches a registered modal. Non-matching anchors are left untouched.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-modal-open], a[href*="#"]');
      if (!trigger) return;

      var id = trigger.getAttribute('data-modal-open');
      if (!id && trigger.tagName === 'A') {
        var hash = (trigger.hash || '').replace(/^#/, '');
        if (!hash) return;
        try { id = decodeURIComponent(hash); } catch (err) { id = hash; }
      }
      if (!id) return;

      // Reserved handle: close the current modal (e.g. a CTA link set to #close).
      if (id === 'close' || id === 'mw-close') {
        var current = trigger.closest('dialog[data-modal-widget]')
          || document.querySelector('dialog[data-modal-widget][open]');
        if (current) { e.preventDefault(); closeModal(current); }
        return;
      }

      if (!dialogFor(id)) return;
      e.preventDefault();
      openModal(id);
    });

    // Close: close buttons + backdrop clicks + Esc (native cancel).
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close]')) {
        var d = e.target.closest('dialog[data-modal-widget]');
        if (d) closeModal(d);
        return;
      }
      // Clicking the ::backdrop reports the <dialog> itself as the target.
      if (e.target.matches('dialog[data-modal-widget]')) closeModal(e.target);
    });

    document.addEventListener('cancel', function (e) {
      if (e.target.matches && e.target.matches('dialog[data-modal-widget]')) {
        e.preventDefault();
        closeModal(e.target);
      }
    }, true);

    // Restore scroll after any dialog closes.
    document.addEventListener('close', function (e) {
      if (e.target.matches && e.target.matches('dialog[data-modal-widget]')) {
        if (!document.querySelector('dialog[data-modal-widget][open]')) {
          document.documentElement.classList.remove('mw-scroll-lock');
        }
      }
    }, true);

    // Deep-link: open a modal if the URL hash matches one on load.
    function openFromHash() {
      var hash = (window.location.hash || '').replace(/^#/, '');
      if (!hash) return;
      try { hash = decodeURIComponent(hash); } catch (e) {}
      openModal(hash);
    }
    if (document.readyState !== 'loading') openFromHash();
    else document.addEventListener('DOMContentLoaded', openFromHash);
  })();

  } catch(e) { console.error(e); }
})();
})();
